import 'scss/solutions/voiceH5.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'
import { player } from 'js/libs/jplayer/init-audio'
$(function () {
  $('.audio-btn').click(function () {
    if ($(this).hasClass('playing')) {
      player.pause()
    } else {
      var type = $(this).data('type')
      var url = `//cdn.aidaxue.com/yinpin/${type}`
      var $this = $(this)
      player.buttonClick({
        wav: `${url}.wav`,
        mp3: `${url}.mp3`
      }, null, function () {
        $('.audio-btn').removeClass('playing')
        $this.addClass('playing')
      }, function () {
        $this.removeClass('playing')
      })
    }
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/solutions/voiceH5.js